export const getStudentDmsEmailDescription = (formData) => {
  const getContact = (data, suffix = '') => {
    const tel = data[`userTel${suffix}`] ?? ''
    const email = suffix === '' ? data.userEmail ?? '' : ''
    return [tel, email].filter(Boolean).join(' / ')
  }

  const policyholder = {
    surname: formData.userSurname ?? '',
    name: formData.userName ?? '',
    patronymic: formData.userPatronymic ?? '',
    contact: getContact(formData),
    gender: formData.userGender ?? '',
    birthdate: formData.userBirthday ?? '',
  }

  const insured = {
    surname: formData.userSurnamePay || policyholder.surname,
    name: formData.userNamePay || policyholder.name,
    patronymic: formData.userPatronymicPay || policyholder.patronymic,
    contact: getContact(formData, 'Pay') || policyholder.contact,
    gender: formData.userGenderPay || policyholder.gender,
    birthdate: formData.userBirthdayPay || policyholder.birthdate,
  }

  const COMMENT = 'оформить полис'
  const PRIVACY = 'согласие получено'
  const PRODUCT = 'Иностранный студент Сеченовского университета'
  const PAGE = window.location.href

  return `
    Фамилия Страхователя: ${policyholder.surname} <br>
    Имя Страхователя: ${policyholder.name} <br>
    Отчество Страхователя: ${policyholder.patronymic} <br>
    Номер телефона/e-mail Страхователя: ${policyholder.contact} <br>
    Пол Страхователя: ${policyholder.gender} <br>
    Дата Рождения Страхователя: ${policyholder.birthdate} <br>
    Фамилия Застрахованного: ${insured.surname} <br>
    Имя Застрахованного: ${insured.name} <br>
    Отчество Застрахованного: ${insured.patronymic} <br>
    Номер телефона: ${insured.contact} <br>
    Пол Застрахованного: ${insured.gender} <br>
    Дата Рождения Застрахованного: ${insured.birthdate} <br>
    Тип оплаты: ${formData.userPayment ?? ''} <br>
    Комментарий: ${COMMENT} <br>
    Политика конфиденциальности: ${PRIVACY} <br>
    Страница сайта: ${PAGE} <br>
    Продукт: ${PRODUCT} <br>
  `.trim()
}

export const getAgentEmailDescription = (formData) => {
  return `
    ФИО: ${formData.userName} <br>
    Рабочий e-mail в домене rgs.ru: ${formData.email} <br>
    ЛНР: ${formData.lnr} <br>
    Номер телефона: ${formData.phone} <br>
    Город: ${formData.city} <br>
    Адрес: ${formData.address} <br>
  `.trim()
}
